import { render, staticRenderFns } from "./right.vue?vue&type=template&id=76d8120e&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=76d8120e&prod&lang=scss"
import style1 from "./right.vue?vue&type=style&index=1&id=76d8120e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d8120e",
  null
  
)

export default component.exports